import React, { Component } from 'react';
import RecommendDR from '../../sections/RecommendDR/RecommendDR';
import { Container, Row, Col } from 'reactstrap';
import MarketData from './MarketData';
import NewsSection from '../../sections/News/News';
import AbooutDR from '../../sections/AboutDR/AboutDR';
import './Home.css';
import { Helmet } from 'react-helmet';

export class Home extends Component {
    static displayName = Home.name;

  render() {
      return (<div id="home-page">
       
      <Container tag="main">
        <RecommendDR />
        <Row className='content-section'>
            <Col><h2>ราคาตลาดปัจจุบัน</h2></Col>
          </Row>
          <Row id="market-data-section">
            <Col lg={7}>
                <MarketData />            
            </Col>
            <Col id="home-page-news"  lg={5}>
                <NewsSection targetSymbol={ "EVERY_SYMBOL" } />
            </Col>
          </Row>
      </Container>
      <AbooutDR />
    </div>);
  }
}
